import React from 'react'

const DocPrintDetails = (props) => {
  const details = props.doc.readDetail
  const delivered = []
  const read = []
  details.map(d => (d.read === true ? read.push(d)
    : delivered.push(d)))

  let read_area = <strong >Este oficio no ha sido leído por ningún destinatario</strong>;
  if(read.length >= 1){
    read_area = (
      <div style={{marginTop: '1em',textJustify: 'justify'}}>
        <span><b>Leído por{(read.length === 1 ? '' : ' [' + read.length + ']')}: </b>
          {read.map(d => (
            <span key={Math.floor(Math.random()*1000)+d.to.id}>{d.to.name.full + '(' + d.to.email + ') - ' + d.read_date}</span>)
          )}.
        </span>
      </div>
    );
  }

  let delivered_area = null;
  if(delivered.length > 0){
    delivered_area = (
      <div style={{marginTop: '.3em',textJustify: 'justify'}}>
          <React.Fragment>
            <b>Entregado a: {'['+ delivered.length + ']'}: </b>
            {delivered.map(d => (
              <span key={Math.floor(Math.random()*1000)+d.to.id} >{d.to.name.full + '(' + d.to.email + ') '}</span>)
            )}
          </React.Fragment>
      </div>
    );
  }

  return (
    <div className='printable'>
        {read_area}
        {delivered_area}
    </div>
  )
}

export default DocPrintDetails



// WEBPACK FOOTER //
// ./src/components/DocPrintDetails.js